/** Registry key for the VhToken entity. */
export const VH_TOKEN = 'VhToken';
//# sourceMappingURL=tokenData.js.map